module.exports = __webpack_public_path__ + "static/img/option_bg.a41d579.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/option_bg.png
// module id = 0qA9
// module chunks = 0